import url from './url';



export default url(({ searchParams }) => `/categories${searchParams ? `?${searchParams}` : ''}`);
